import * as t from 'io-ts';
import { nonEmptyString } from '../utils';

const Recaptcha = t.exact(t.interface({
  siteKey: nonEmptyString,
}), 'Recaptcha');

export type IRecaptcha = t.TypeOf<typeof Recaptcha>;

export default Recaptcha;
